import React from 'react';
import { ColorPicker } from './ColorPicker';
import { LogoUploader } from './LogoUploader';
import { TextCustomization } from './TextCustomization';
import { MiniAppColorPicker } from './MiniAppColorPicker';
import { ThemeSettings } from './ThemeSettings';
import { QuickActionsSettings } from './QuickActionsSettings';

export function DesignControls() {
  return (
    <div className="space-y-6">
      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Theme</h3>
        <ThemeSettings />
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Chatbot colors</h3>
        <ColorPicker />
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Buttons colors</h3>
        <MiniAppColorPicker />
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Logo and icons</h3>
        <LogoUploader />
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Texts</h3>
        <TextCustomization />
      </div>

      <div className="bg-white/5 backdrop-blur-xl rounded-xl p-6 border border-white/10">
        <h3 className="text-lg font-semibold text-white mb-4">Quick actions</h3>
        <QuickActionsSettings />
      </div>
    </div>
  );
}